import React from 'react';
import ReactDOM from 'react-dom';
import { Redirect, BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'antd/dist/antd.css';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import store from './redux/store.js';
import App from './pages/App';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import {FullScreenUrl} from './pages';
import {asyncComponent} from './utils/asyncComponent';
import  './utils/td.css';
import engLogin from "./pages/engLogin";


// URL带ID字段的特殊传参用法  path="/weblogin/:groupid/:subgroup"	


ReactDOM.render((
<Provider store = {store}>
  <Router >	
	<Switch>		
		<Route exact path="/login"  component={Login}/>
		<Route exact path="/engLogin"  component={engLogin}/>
		<Route exact path="/error"  component={NotFound}/>
		<Route exact path="/fullscreen"  component={FullScreenUrl}/>
		<Route path="/"   component={App} />
		<Redirect to="/error"  />
	  </Switch>	
  </Router>
</Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

//加载socketio服务
console.log('start conection to socket server');


